import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import LoginHeader from '../../../Login_header';
import Menu from '../../../Menu';
import * as Common from '../../../Common';
import Dialog from '../../../Dialog';
import * as Picklist from "../../../Picklist";


const Rep_Profitablitity_Ad2_Analysis = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    console.log('sid', sid);
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    // date and generate type state management
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [generateType, setGenerateType] = useState("V");

    const [scr, setScr] = useState("")
    const [filterLocationType, setFilterLocationType] = useState("O");
    const [filterLocation, setFilterLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_ADII_ANALYSIS'], function (result) {
                let resp = JSON.parse(result);
                console.log("result", resp);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setFilterLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }

    const handleLocationType = (e) => {
        setFilterLocationType(e.target.value);
        if (e.target.value === 'A') {
            setLocationCode(0);
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
        }
    }

    const handleGenerate = () => {
        $(".loader").show();
        if (fromDate > toDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        const obj = {
            filterLocationType: filterLocationType,
            locationCode: locationCode,
            type: generateType === 'V' ? 'V' : 'D',
            radioTypeLocation: filterLocationType,
            fromDateDMY: Common.dateDMY(fromDate),
            fromDate: Common.dateYMD(fromDate),
            toDateDMY: Common.dateDMY(toDate),
            toDate: Common.dateYMD(toDate)
        };

        if (generateType === 'V') {
            Common.callApi(Common.apiAd2Analysis, [sid, 'viewReport', JSON.stringify(obj)], (result) => {
                var newWindow = window.open();
                newWindow.document.write(result);
                $(".loader").hide();
            });
        } else if (generateType === 'D') {
            Common.callDownloadApiPost1(Common.apiAd2Analysis, "post", [sid, 'donwloadReport', JSON.stringify(obj)], (result) => {
                setMsgText(Common.buildMessageFromArray([result]));
                setMsgBox(true);
                $(".loader").hide();
            });
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                {scr === "" ?
                    <>
                        <Row>
                            <Col>
                                <h3>Ad-II Analysis</h3>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={filterLocationType} onChange={handleLocationType}
                                        required>
                                        <option value="O">One</option>
                                        <option value="A">All</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {filterLocationType === 'O' ? <>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={filterLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col></> : null}
                        </Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                    <DatePicker className="form-control"
                                        selected={fromDate}
                                        onChange={(date) => setFromDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>

                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                    <DatePicker className="form-control"
                                        selected={toDate}
                                        onChange={(date) => setToDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={generateType} onChange={e => setGenerateType(e.target.value)}
                                        required>
                                        <option value="V">View</option>
                                        <option value="D">Download</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                    </> : null}
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_Profitablitity_Ad2_Analysis;